import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import styles from './VerticalStepper.module.scss';
// figma references
// https://www.figma.com/file/N8zv2DlsBFKxrHIqOoOZo2/New-Client-Flow?node-id=2260%3A12463
// https://www.figma.com/file/5hgskCBBvA7FMLu1phSNnr/Vendor-transparency?node-id=109%3A3534
export function VerticalStepper(_0) {
    let { steps, onStepClick = ()=>{}, activeStepIndex, className, testId } = _0, props = _object_without_properties(_0, [
        "steps",
        "onStepClick",
        "activeStepIndex",
        "className",
        "testId"
    ]);
    const randomId = useMemo(()=>String(Math.random()), []);
    const buttonId = testId !== null && testId !== void 0 ? testId : randomId;
    return /*#__PURE__*/ _jsx("ol", _object_spread_props(_object_spread({
        className: cn(styles.root, className),
        "data-testid": testId
    }, props), {
        children: steps.map((param, index)=>{
            let { component, disabled, completed, active, stepIconType = 'checkmark' } = param;
            const prevStep = steps[index - 1];
            const nextStep = steps[index + 1];
            let iconComponent = /*#__PURE__*/ _jsx(StepIcon, {
                testId: "".concat(testId, "-status-icon-").concat(index),
                completed: completed,
                active: active != null ? active : index === activeStepIndex
            });
            if (stepIconType === 'clock') {
                iconComponent = /*#__PURE__*/ _jsx(ClockIcon, {});
            } else if (stepIconType === 'warning') {
                iconComponent = /*#__PURE__*/ _jsx(WarningIcon, {});
            }
            return /*#__PURE__*/ _jsxs("li", {
                "aria-current": index === activeStepIndex && 'step',
                "data-testid": "".concat(testId, "-step-").concat(index),
                className: cn(styles.step, {
                    [styles.active]: active || index === activeStepIndex,
                    [styles.completed]: completed,
                    [styles.prevActive]: (active || completed) && prevStep && (prevStep.completed || prevStep.active),
                    [styles.nextActive]: (active || completed) && nextStep && (nextStep.completed || nextStep.active)
                }),
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: styles.stepIconContainer,
                        children: /*#__PURE__*/ _jsx("button", {
                            id: "".concat(buttonId, "-").concat(index),
                            className: styles.stepButton,
                            "aria-label": "Step ".concat(index + 1),
                            onClick: ()=>{
                                onStepClick(index);
                            },
                            disabled: disabled,
                            "data-testid": "".concat(testId, "-step-").concat(index, "-btn"),
                            "data-completed": completed,
                            "data-icon": stepIconType,
                            children: iconComponent
                        })
                    }),
                    /*#__PURE__*/ _jsx("label", {
                        htmlFor: "".concat(buttonId, "-").concat(index),
                        className: styles.stepContent,
                        "data-testid": "".concat(testId, "-step-").concat(index, "-txt"),
                        children: component
                    })
                ]
            }, index);
        })
    }));
}
const StepIcon = (param)=>{
    let { active, testId, completed = false } = param;
    if (active || completed) {
        return /*#__PURE__*/ _jsxs("svg", {
            "data-testid": testId,
            "data-status": completed ? 'completed' : 'active',
            width: "18",
            height: "18",
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                completed && // the actual checkmark
                /*#__PURE__*/ _jsx("path", {
                    d: "M11.7305 7.23047L7.79303 11.168L5.82428 9.19922",
                    stroke: "currentColor",
                    strokeWidth: "1.3",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M9 0.65C13.6116 0.65 17.35 4.38842 17.35 9C17.35 13.6116 13.6116 17.35 9 17.35C4.38842 17.35 0.65 13.6116 0.65 9C0.65 4.38842 4.38842 0.65 9 0.65Z",
                    stroke: "currentColor",
                    strokeWidth: "1.3",
                    strokeMiterlimit: "10"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("svg", {
        "data-testid": testId,
        "data-status": "inactive",
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z",
            fill: "currentColor"
        })
    });
};
const ClockIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M8.965 4.225a.563.563 0 0 0-1.125 0v5.866c0 .202.108.388.282.488l3.973 2.284a.562.562 0 1 0 .56-.976l-3.69-2.121v-5.54Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M9 .169A8.831 8.831 0 1 0 9 17.83 8.831 8.831 0 0 0 9 .17Zm-7.707 8.83a7.706 7.706 0 1 1 15.413 0A7.706 7.706 0 0 1 1.293 9Z",
                clipRule: "evenodd"
            })
        ]
    });
const WarningIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                d: "M9 4.5c.31 0 .563.252.563.563v5.062a.563.563 0 0 1-1.126 0V5.063c0-.311.252-.563.563-.563ZM9.844 12.656a.844.844 0 1 1-1.688 0 .844.844 0 0 1 1.688 0Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M9 .169A8.831 8.831 0 1 0 9 17.83 8.831 8.831 0 0 0 9 .17ZM1.293 9a7.706 7.706 0 1 1 15.413 0A7.706 7.706 0 0 1 1.293 9Z",
                clipRule: "evenodd"
            })
        ]
    });
